import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _inherits from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imagetextalternative/imagetextalternativecommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { isImage } from "../image/utils";
/**
 * The image text alternative command. It is used to change the `alt` attribute of `<image>` elements.
 *
 * @extends module:core/command~Command
 */

var ImageTextAlternativeCommand = /*#__PURE__*/function (_Command) {
  _inherits(ImageTextAlternativeCommand, _Command);

  var _super = _createSuper(ImageTextAlternativeCommand);

  function ImageTextAlternativeCommand() {
    _classCallCheck(this, ImageTextAlternativeCommand);

    return _super.apply(this, arguments);
  }

  _createClass(ImageTextAlternativeCommand, [{
    key: "refresh",

    /**
     * The command value: `false` if there is no `alt` attribute, otherwise the value of the `alt` attribute.
     *
     * @readonly
     * @observable
     * @member {String|Boolean} #value
     */

    /**
     * @inheritDoc
     */
    value: function refresh() {
      var element = this.editor.model.document.selection.getSelectedElement();
      this.isEnabled = isImage(element);

      if (isImage(element) && element.hasAttribute('alt')) {
        this.value = element.getAttribute('alt');
      } else {
        this.value = false;
      }
    }
    /**
     * Executes the command.
     *
     * @fires execute
     * @param {Object} options
     * @param {String} options.newValue The new value of the `alt` attribute to set.
     */

  }, {
    key: "execute",
    value: function execute(options) {
      var model = this.editor.model;
      var imageElement = model.document.selection.getSelectedElement();
      model.change(function (writer) {
        writer.setAttribute('alt', options.newValue, imageElement);
      });
    }
  }]);

  return ImageTextAlternativeCommand;
}(Command);

export { ImageTextAlternativeCommand as default };